import { ConcreteEncodable } from "./ConcreteEncodable";

import { BranchImplEncoder } from "../../encoder/BranchImplEncoder";

import * as CubiqTS from "../../index";
import { Branch } from "../Branch";

export class BranchImpl extends ConcreteEncodable implements Branch {
  public static enType: string = "com.bcdfx.model.BranchImpl";

  /*FID=1*/
  public branchId: string;
  /*FID=2*/
  public branchName: string;
  /*FID=3*/
  public timeZoneCd: string;
  /*FID=4*/
  public parentBranchCd: string;
  /*FID=5*/
  public allowBenchmarkOrdersFg: boolean;
  /*FID=6*/
  public allowLimitOrdersFg: boolean;
  /*FID=7*/
  public straightThroughProcessingFg: boolean;
  /*FID=8*/
  public creditCheckFg: boolean;
  /*FID=9*/
  public privateFg: boolean;
  /*FID=10*/
  public creditCentre: string;
  /*FID=11*/
  public restrictGoodUntilFg: boolean;
  /*FID=12*/
  public goodUntilTime: CubiqTS.Long | null = null;
  /*FID=13*/
  public goodUntilTzCd: string;
  /*FID=14*/
  public allowMarketOrdersFg: boolean;
  /*FID=15*/
  public applyMarkupFg: boolean;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = BranchImplEncoder.Instance;
    this.setEncodableType(BranchImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "BranchImpl[" +
      "branchId=" +
      this.branchId +
      "branchName=" +
      this.branchName +
      "timeZoneCd=" +
      this.timeZoneCd +
      "parentBranchCd=" +
      this.parentBranchCd +
      "allowBenchmarkOrdersFg=" +
      this.allowBenchmarkOrdersFg +
      "allowLimitOrdersFg=" +
      this.allowLimitOrdersFg +
      "straightThroughProcessingFg=" +
      this.straightThroughProcessingFg +
      "creditCheckFg=" +
      this.creditCheckFg +
      "privateFg=" +
      this.privateFg +
      "creditCentre=" +
      this.creditCentre +
      "restrictGoodUntilFg=" +
      this.restrictGoodUntilFg +
      "goodUntilTime=" +
      this.goodUntilTime +
      "goodUntilTzCd=" +
      this.goodUntilTzCd +
      "allowMarketOrdersFg=" +
      this.allowMarketOrdersFg +
      "applyMarkupFg=" +
      this.applyMarkupFg +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
